const _ = require('lodash');

module.exports = function ($sce, settingsService, $stateParams, searchService, searchPhraseActionService, $state, shopper) {
    function SearchExternalResultsController() {

        // If the search phrase isn't associated with an action
        // Or if the action was to prompt for login and user is not a guest, do normal search
        searchPhraseActionService.getSearchPhraseAction($stateParams.searchTerm).then(function (action) {
            if (!action || (action.Action === searchPhraseActionService.action.login && !shopper.currentUser.isGuest)) {
                searchService.getSearchCounts($stateParams.searchTerm).then(function () {
                    const nextState = searchService.determineStateToShow($stateParams.searchTerm);
                    $state.go(nextState.name,
                        _.assign({
                                productId: undefined,
                                recipeId: undefined,
                                cardId: undefined,
                                name: undefined,
                                pageNumber: undefined
                            },
                            nextState.params));
                });
            }
        });

        searchService.resetResults();

        settingsService.getSettingValue('Search', 'SearchResultInNewTab').then(setting => {
            const message = setting.replace('{searchTerm}', $stateParams.searchTerm).trim();
            this.ExternalResultMessage = $sce.trustAsHtml(message);
        });
    }

    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SearchExternalResultsController],
        template: '<div class="search-zero-results-wrapper" wow-hide-scroll wow-scrollbar><div class="search-zero-results-wrapper-blurb" ng-bind-html="ctrl.ExternalResultMessage"></div></div>'
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-externalresult-directive.js
 **/